import React, { Dispatch } from 'react';
import { AnyAction } from 'redux-starter-kit';
import { connect } from 'react-redux';

interface GlobalDispatchProps {
  globalDispatch: (action: AnyAction) => void;
}

class GlobalDispatchWatcher extends React.Component<GlobalDispatchProps> {
  public static Instance: GlobalDispatchWatcher;

  constructor(props: GlobalDispatchProps) {
    super(props);
    GlobalDispatchWatcher.Instance = this;
  }

  public static dispatch(action: AnyAction) {
    GlobalDispatchWatcher.Instance.props.globalDispatch(action);
  }

  public render() {
    return <></>;
  }
}

export const globalDispatch = (action: AnyAction) => {
  GlobalDispatchWatcher.dispatch(action);
};

export default connect(
  null,
  (dispatch: Dispatch<AnyAction>): GlobalDispatchProps => ({
    globalDispatch: action => dispatch(action),
  }),
)(GlobalDispatchWatcher);
